// extracted by mini-css-extract-plugin
export default {"1200":"(min-width: 1200px)","col":"Sfkx07wqEkm6x_oZuh6V","sidebar":"j3Mo8_5YtDRKbl5IN26J"};